const cardItems = [
  {
    title: '2026暑期档观影指南',
    desc: '今年暑期档大片云集，从动作巨制到温情文艺片，密桃视频为您盘点不可错过的15部必看影片，持续更新中。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20scene%20with%20warm%20golden%20sunlight%2C%20film%20projector%20light%20beam%2C%20classic%20cinema%20aesthetic%2C%20rich%20amber%20tones%2C%20nostalgic%20theater%20atmosphere%2C%20no%20text%20no%20people&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '编辑推荐',
    date: '2026-07-31',
  },
  {
    title: '久久视频高清修复片单：那些被时间遗忘的经典',
    desc: '久久视频专区最新上线50部高清修复经典影片，4K画质重温华语电影黄金时代的永恒魅力。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Classic%20film%20restoration%20visual%20with%20vintage%20movie%20camera%20and%20film%20reels%2C%20warm%20sepia%20and%20golden%20tones%2C%20nostalgic%20cinema%20aesthetic%2C%20old%20Hollywood%20glamour%2C%20no%20text%20no%20people&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '资源推荐',
    date: '2026-07-30',
  },
  {
    title: '91视频网站观影体验全面升级：更快更清晰',
    desc: '91在线视频播放器完成重大升级，全面支持4K超清画质，加载速度提升40%，观影体验再上新高度。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20soft%20ambient%20lighting%2C%20premium%20audio%20equipment%2C%20cozy%20atmosphere%2C%20warm%20dark%20tones%2C%20no%20text%20no%20people&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '产品动态',
    date: '2026-07-28',
  },
  {
    title: '从《暗夜追踪者》看华语动作片的进化之路',
    desc: '新一代华语动作片不再局限于传统武打，融合悬疑、科幻元素，呈现出更丰富的叙事层次与视觉表达。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20film%20scene%20with%20dramatic%20lighting%20and%20cinematic%20composition%2C%20urban%20night%20setting%2C%20film%20noir%20aesthetic%2C%20deep%20contrast%2C%20atmospheric%20mood%2C%20no%20text%20no%20people&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '深度影评',
    date: '2026-07-25',
  },
  {
    title: '动漫频道改版上线：追番体验全面进化',
    desc: '全新动漫频道界面更简洁，支持个性化追番列表与更新提醒，热门新番第一时间推送，不再错过任何精彩。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20scene%20with%20vibrant%20colors%20and%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20cel%20shading%20look%2C%20warm%20and%20vivid%20tones%2C%20entertainment%20atmosphere%2C%20no%20text%20no%20characters&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '功能更新',
    date: '2026-07-22',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-layout-masonry-line text-accent-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">精选推荐</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11">编辑精选好文与影片推荐，发现更多精彩内容</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer ${
                i === 0 ? 'md:col-span-2 lg:col-span-3' : ''
              }`}
            >
              <div className={`flex flex-col ${i === 0 ? 'md:flex-row' : ''}`}>
                <div className={`overflow-hidden bg-background-200 ${i === 0 ? 'md:w-2/5 md:shrink-0' : ''}`}>
                  <div className={i === 0 ? 'aspect-[16/9] md:aspect-[4/3] md:h-full' : 'aspect-[16/10]'}>
                    <img
                      src={item.imgUrl}
                      alt={`${item.title} - 密桃视频精选`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="p-4 md:p-6 flex flex-col justify-center">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}